// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-container {
  margin-bottom: 1.5rem;
}

.select {
  position: relative;
  width: 100%;
}

.select-text {
  height: 48px;
  position: relative;
  font-family: inherit;
  background-color: transparent;
  width: 100%;
  padding: 10px 10px 10px 16px;
  font-size: 1rem;
  border-radius: 4px;
  border: 1px solid #c2c2c2;
  color: #323233;
}

/* Remove focus */
.select-text:focus {
  outline: none;
  border: 1px solid #0072ea;
}

/* Use custom arrow */
.select .select-text {
  appearance: none;
  -webkit-appearance: none;
  color: #323233;
}

.select:after {
  position: absolute;
  top: 21px;
  right: 10px;
  /* Styling the down arrow */
  width: 0;
  height: 0;
  padding: 0;
  content: "";
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #4d4d4d;
  pointer-events: none;
}

/* LABEL ======================================= */
.select-label {
  color: #323233;
  background: white;
  font-size: 1rem;
  font-weight: 400;
  position: absolute;
  pointer-events: none;
  padding: 0 5px;
  left: 12px;
  top: 10px;
  transition: 0.2s ease all;
}

/* active state */
.select-text:focus ~ .select-label,
.select-text:valid ~ .select-label {
  color: #0072ea;
  top: -8px;
  transition: 0.2s ease all;
  font-size: 0.8rem;
}

.select-text:valid:not(focus) ~ .select-label {
  color: #323233;
  font-weight: 400;
}

.select-text:valid:focus ~ .select-label {
  color: #0072ea;
  font-weight: 400;
}

.notices .custom-container .content-section {
  background: #E0E7FF;
  padding: 4rem 1rem;
  min-height: 55vh;
}
.notices .custom-container .content-section .page-title {
  font-size: 2.2rem;
  text-align: center;
  color: #08245A;
}
.notices .custom-container .content-section .page-title::after {
  content: "";
  display: block;
  height: 8px;
  width: 60px;
  background: #08245A;
  margin: 0.7rem auto 0;
  border-radius: 20px;
}
.notices .custom-container .content-section .content-body {
  max-width: 900px;
  margin: 2rem auto 0;
  border-radius: 3px;
  font-family: "Roboto", "SolaimanLipi", sans-serif;
}
.notices .custom-container .content-section .content-body .notice-table {
  background: #fff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
}
.notices .custom-container .content-section .content-body .notice-table thead th {
  background: #2E3A91;
  color: #fff;
  font-weight: 500;
  border: 1px solid #D1D1D1;
}
.notices .custom-container .content-section .content-body .notice-table td, .notices .custom-container .content-section .content-body .notice-table th {
  border: 2px solid #E1E2E2;
  padding: 1rem;
  vertical-align: middle;
}
.notices .custom-container .content-section .content-body .notice-table tbody tr td {
  color: #5A5A5A;
}
.notices .custom-container .content-section .content-body .notice-table tbody tr td:nth-child(1),
.notices .custom-container .content-section .content-body .notice-table tbody tr td:nth-child(3),
.notices .custom-container .content-section .content-body .notice-table tbody tr td:nth-child(4) {
  text-align: center;
}
.notices .custom-container .content-section .content-body .select-label {
  background: #E0E7FF;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/common/components/_select.scss","webpack://./src/assets/css/pages/allNotices/style.scss","webpack://./src/assets/css/common/_variables.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;ACCF;;ADEA;EACE,kBAAA;EACA,WAAA;ACCF;;ADEA;EACE,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,6BAAA;EACA,WAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;ACCF;;ADEA,iBAAA;AACA;EACE,aAAA;EACA,yBAAA;ACCF;;ADEA,qBAAA;AACA;EACE,gBAAA;EACA,wBAAA;EACA,cAAA;ACCF;;ADEA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,2BAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,kCAAA;EACA,mCAAA;EACA,6BAAA;EACA,oBAAA;ACCF;;ADEA,kDAAA;AACA;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,UAAA;EACA,SAAA;EACA,yBAAA;ACCF;;ADEA,iBAAA;AACA;;EAEE,cAAA;EACA,SAAA;EACA,yBAAA;EACA,iBAAA;ACCF;;ADEA;EACE,cAAA;EACA,gBAAA;ACCF;;ADCA;EACE,cAAA;EACA,gBAAA;ACEF;;AA3EI;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;AA8EN;AA5EM;EACE,iBCCK;EDAL,kBAAA;EACA,cAAA;AA8ER;AA5EQ;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;AA8EV;AA1EM;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iDAAA;AA4ER;AA1EQ;EACE,gBAAA;EACA,2CAAA;AA4EV;AAzEY;EACE,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;AA2Ed;AAvEU;EACE,yBAAA;EACA,aAAA;EACA,sBAAA;AAyEZ;AApEc;EACE,cAAA;AAsEhB;AAnEc;;;EAGE,kBAAA;AAqEhB;AAhEQ;EACE,mBAAA;AAkEV","sourcesContent":[".select-container{\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.select {\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n.select-text {\r\n  height: 48px;\r\n  position: relative;\r\n  font-family: inherit;\r\n  background-color: transparent;\r\n  width: 100%;\r\n  padding: 10px 10px 10px 16px;\r\n  font-size: 1rem;\r\n  border-radius: 4px;\r\n  border: 1px solid #c2c2c2;\r\n  color: #323233;\r\n}\r\n\r\n/* Remove focus */\r\n.select-text:focus {\r\n  outline: none;\r\n  border: 1px solid #0072ea;\r\n}\r\n\r\n/* Use custom arrow */\r\n.select .select-text {\r\n  appearance: none;\r\n  -webkit-appearance: none;\r\n  color: #323233;\r\n}\r\n\r\n.select:after {\r\n  position: absolute;\r\n  top: 21px;\r\n  right: 10px;\r\n  /* Styling the down arrow */\r\n  width: 0;\r\n  height: 0;\r\n  padding: 0;\r\n  content: \"\";\r\n  border-left: 5px solid transparent;\r\n  border-right: 5px solid transparent;\r\n  border-top: 5px solid #4d4d4d;\r\n  pointer-events: none;\r\n}\r\n\r\n/* LABEL ======================================= */\r\n.select-label {\r\n  color: #323233;\r\n  background: white;\r\n  font-size: 1rem;\r\n  font-weight: 400;\r\n  position: absolute;\r\n  pointer-events: none;\r\n  padding: 0 5px;\r\n  left: 12px;\r\n  top: 10px;\r\n  transition: 0.2s ease all;\r\n}\r\n\r\n/* active state */\r\n.select-text:focus ~ .select-label,\r\n.select-text:valid ~ .select-label {\r\n  color: #0072ea;\r\n  top: -8px;\r\n  transition: 0.2s ease all;\r\n  font-size: 0.8rem;\r\n}\r\n\r\n.select-text:valid:not(focus) ~ .select-label {\r\n  color: #323233;\r\n  font-weight: 400;\r\n}\r\n.select-text:valid:focus ~ .select-label {\r\n  color: #0072ea;\r\n  font-weight: 400;\r\n}\r\n","@import \"./src/assets/css/common/variables\";\r\n@import \"./src/assets/css/common/components/select\";\r\n\r\n.notices {\r\n\r\n  .custom-container {\r\n    .content-section {\r\n      background: #E0E7FF;\r\n      padding: 4rem 1rem;\r\n      min-height: 55vh;\r\n\r\n      .page-title {\r\n        font-size: $page-title;\r\n        text-align: center;\r\n        color: #08245A;\r\n\r\n        &::after {\r\n          content: \"\";\r\n          display: block;\r\n          height: 8px;\r\n          width: 60px;\r\n          background: #08245A;\r\n          margin: .7rem auto 0;\r\n          border-radius: 20px;\r\n        }\r\n      }\r\n\r\n      .content-body {\r\n        max-width: 900px;\r\n        margin: 2rem auto 0;\r\n        border-radius: 3px;\r\n        font-family: \"Roboto\", \"SolaimanLipi\", sans-serif;\r\n\r\n        .notice-table {\r\n          background: #fff;\r\n          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);\r\n\r\n          thead {\r\n            th {\r\n              background: #2E3A91;\r\n              color: #fff;\r\n              font-weight: 500;\r\n              border: 1px solid #D1D1D1;\r\n            }\r\n          }\r\n\r\n          td, th {\r\n            border: 2px solid #E1E2E2;\r\n            padding: 1rem;\r\n            vertical-align: middle;\r\n          }\r\n\r\n          tbody {\r\n            tr {\r\n              td {\r\n                color: #5A5A5A;\r\n              }\r\n\r\n              td:nth-child(1),\r\n              td:nth-child(3),\r\n              td:nth-child(4) {\r\n                text-align: center;\r\n              }\r\n            }\r\n          }\r\n        }\r\n        .select-label {\r\n          background: #E0E7FF;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Color palette\r\n$color-blue-light: #d0dbff;\r\n$color-blue: #354e80;\r\n$color-blue-dark: #1c2f56;\r\n\r\n$color-sky: #e0e7ff;\r\n\r\n$color-yellow-light: #fffdef;\r\n$color-yellow: #fae205;\r\n\r\n$color-black-30: #e1e2e2;\r\n\r\n$section-heading-font-size: 2.1rem;\r\n$page-title: 2.2rem;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
